// news-brief 纯 SVG 渲染。复用 tick.newsIdx 推导当前头条。
import type { SceneData } from '../../api/types'
import type { NewsData } from './types'
import { newsIdx } from './tick'
import { COLORS, FONT_SANS, FONT_MONO, esc, wrapText, textBlock } from '../../export/svgRender'

export function render(data: SceneData, time: number): string {
  const d = data as unknown as NewsData
  const idx = newsIdx(data, time)
  const headlines = d.headlines || []

  if (!headlines[idx]) {
    return `
  <text x="540" y="960" font-size="56" font-weight="700" fill="${COLORS.t3}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">End of briefing</text>`
  }

  const h = headlines[idx]
  const cat = (d.category || '').toUpperCase()
  const catW = Math.max(220, cat.length * 32 * 0.62 + 84)
  const cardX = 60, cardY = 360, cardW = 960, cardH = 760
  const titleLines = wrapText(h.title || '', 64, 840)
  const titleY = 600 - ((titleLines.length - 1) * 64 * 1.3) / 2

  return `
  <rect x="${540 - catW / 2}" y="180" width="${catW}" height="68" rx="34" ry="34" fill="${COLORS.pSubtle}"/>
  <text x="540" y="214" font-size="32" font-weight="700" fill="${COLORS.pHover}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(cat)}</text>
  <rect x="${cardX}" y="${cardY}" width="${cardW}" height="${cardH}" rx="28" ry="28" fill="rgba(255,255,255,0.04)"/>
  <rect x="${cardX}" y="${cardY}" width="6" height="${cardH}" fill="${h.color}"/>
  <circle cx="${cardX + 76}" cy="470" r="11" fill="${h.color}"/>
  <text x="${cardX + 110}" y="470" font-size="36" font-weight="400" fill="${COLORS.t3}" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(h.source)} · ${esc(h.time)}</text>
${textBlock(titleLines, 540, titleY, 64, COLORS.w, { anchor: 'middle', weight: 700 })}
  <text x="540" y="1560" font-size="28" font-weight="400" fill="${COLORS.t4}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_MONO}">${idx + 1} / ${headlines.length}</text>`
}
